import DoAPICall from './DoAPICall'

//Create Survey Question List Type
export async function createSurveyQuestionListTypes(userToken, SurveyQuestionListType){
	const apiPayload = {
		httpMethod:'post',
		userToken,
		uri:'surveyquestionlisttypes',
		payLoad:{
			client_id:SurveyQuestionListType.client_id,
			description:SurveyQuestionListType.description,
			name:SurveyQuestionListType.name
		},
		requestOptions:{}
	}
	return await DoAPICall(apiPayload)
}

//Get All Survey Question List Type
export async function getSurveyQuestionListTypes(userToken){
	const apiPayload = {
		httpMethod:'get',
		userToken,
		uri:'surveyquestionlisttypes',
		payLoad:{},
		requestOptions:{}
	}
	return await DoAPICall(apiPayload)
}

//Get All Survey Question List Type
export async function getSurveyQuestionListTypesOfClient(userToken,client_id){
	const apiPayload = {
		httpMethod:'get',
		userToken,
		uri:'surveyquestionlisttypes?client_id='+client_id,
		payLoad:{},
		requestOptions:{}
	}
	return await DoAPICall(apiPayload)
}

//Get One Survey Question List Type
export async function getSurveyQuestionListType(userToken, id){
	const apiPayload = {
		httpMethod:'get',
		userToken,
		uri:'surveyquestionlisttypes/'+id,
		payLoad:{},
		requestOptions:{}
	}
	return await DoAPICall(apiPayload)
}

//Update Survey Question List Type
export async function updateSurveyQuestionListType(userToken, SurveyQuestionListType){
	const apiPayload = {
		httpMethod:'put',
		userToken,
		uri:'surveyquestionlisttypes/'+SurveyQuestionListType.id,
		payLoad:{
				description:SurveyQuestionListType.description,
				name:SurveyQuestionListType.name
			},
		requestOptions:{}
	}
	return await DoAPICall(apiPayload)
}

//Delete Survey Question List Type
export async function deleteSurveyQuestionListType(userToken, id){
    const apiPayload = {
        httpMethod:'delete',
        userToken,
        uri:'surveyquestionlisttypes/'+id,
        payLoad:{},
        requestOptions:{}
    }
    return await DoAPICall(apiPayload)
}